"use client";

import { useNavigate, useLocation } from "react-router-dom";
import { addLanguageToPath, getLanguageFromPath } from "@/lib/language";

/**
 * Hook for language-aware navigation
 * Automatically preserves the current language when navigating
 */
export function useLanguageNavigate() {
  const navigate = useNavigate();
  const location = useLocation();

  const languageNavigate = (path: string, options?: { replace?: boolean }) => {
    // Get current language from URL
    const currentLang = getLanguageFromPath(location.pathname);

    // Add current language prefix to the new path
    const localizedPath = addLanguageToPath(path, currentLang);

    // Navigate with language preserved
    navigate(localizedPath, options);
  };

  return languageNavigate;
}